class HandlerFilters {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.sections = this.sectionsContainer.getElementsByClassName("container-filters");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        Array.from(this.sections).forEach((section) =>
            this.initDesplegables(section)
        );
    }

    initDesplegables(section) {
        const handlerFilters = section.querySelector('.handler-filters');
        const wrapperFilters = section.querySelector('.wrapper-filters');
        
        if (handlerFilters && wrapperFilters) {
            const handlers = handlerFilters.querySelectorAll('.btn-filter');
            const filtersTarget = wrapperFilters.querySelectorAll('.filters');

            handlers.forEach(handler => {
                handler.addEventListener('click', () => {
                    handlers.forEach(btn => btn.classList.remove('active'));
                    handler.classList.add('active');
                    //console.log(handler);
                    
                    const idTarget = handler.getAttribute('id').replace("btn-filter-", "");
                    //console.log(wrapperFilters)
                    //console.log(filtersTarget)
                    
                    filtersTarget.forEach(wrapper => wrapper.classList.remove('active'));
                    filtersTarget.forEach(wrapper => {
                        //console.log(wrapper.id)
                        //console.log(wrapper.id.includes(idTarget))
                        if (wrapper.id.includes(idTarget)) {
                            wrapper.classList.add('active');
                        }
                    });
                });
            });
        }
    }
}

export default HandlerFilters;
